import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { BrowserSupportService } from '../../shared/services/browser-support/browser-support.service';

@Component({
  selector: 'app-unsupported-browser',
  templateUrl: './unsupported-browser.component.html',
  styleUrls: ['../errors.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [TranslatePipe],
})
export class UnsupportedBrowserComponent {
  private router = inject(Router);
  private browserSupport = inject(BrowserSupportService);

  constructor() {
    const router = this.router;
    const browserSupport = this.browserSupport;

    browserSupport.browserIsSupported$.subscribe((supported) => {
      if (supported) {
        router.navigate(['/']);
      }
    });
  }
}
